//converting relative paths to absolute paths
export const convertRelativePaths = (path = "") => {
    const url = new URL(path, window.location.protocol + window.location.host);
    return url.href;
};